/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay.clientSubstatusOverlayNew{height:100%}.overlay.clientSubstatusOverlayNew .content{box-shadow:none}.overlay.clientSubstatusOverlayNew .ol-main{background:#f5f5f5}"];
export { styles as styles };
